import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
} from '@angular/core';

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-tooltip',
  styleUrl: './tooltip.scss',
  templateUrl: './tooltip.html',
})
export class TooltipComponent {
  /** Texte de l'infobulle. */
  readonly text = input.required<string>();

  /** Position de l'infobulle par rapport au déclencheur. */
  readonly position = input<TooltipPosition>('top');

  protected readonly visible = signal(false);

  private readonly elementRef = inject(ElementRef);

  protected show(): void {
    this.visible.set(true);
  }

  protected hide(): void {
    this.visible.set(false);
  }

  @HostListener('focusin')
  protected onFocusIn(): void {
    this.show();
  }

  @HostListener('focusout')
  protected onFocusOut(): void {
    this.hide();
  }

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    this.hide();
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    const host = this.elementRef.nativeElement as HTMLElement;
    if (!host.contains(event.target as Node)) {
      this.hide();
    }
  }
}
